/**
 * AddonCard component.
 */
import Addon from '@shared/classes/addon';
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/tickAddonContainer';
import Tick from '@components/atoms/icons/tick';
import HorizontalCard from './horizontalCard';
import { memo } from 'react';

function AddonCard(props: Card) {
  const checkAddon =
    (props.item as Addon).checkAddon && (props.item as Addon).checkAddon();
  return (
    <HorizontalCard {...props} showInfo={false} showMask={false}>
      {checkAddon ? (
        <Container>
          <Tick />
        </Container>
      ) : (
        <></>
      )}
    </HorizontalCard>
  );
}

export default memo(AddonCard);
